<template>
  <v-layout fluid>
    <v-btn-toggle v-model="$i18n.locale" tile group mandatory>
      <v-btn @click="setLocale('lv')" value="lv">
        <country-flag country="lv" size="normal" />
      </v-btn>
      <v-btn @click="setLocale('ru')" value="ru">
        <country-flag country="ru" size="normal" />
      </v-btn>
      <v-btn @click="setLocale('en')" value="en">
        <country-flag country="gb" size="normal" />
      </v-btn>
    </v-btn-toggle>
  </v-layout>
</template>
<script>
import app from "@/app.js";
import CountryFlag from "vue-country-flag";

export default {
  components: { CountryFlag },
  props: ["value"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    setLocale(v) {
      app.setLocale(v);
    }
  }
};
</script>script


<style lang="scss" scoped>
</style>